import HeroSection from './components/HeroSection';
import OverviewSection from './components/OverviewSection';
import ApproachSection from './components/ApproachSection';
import FocusSection from './components/FocusSection';
import PhilosophySection from './components/PhilosophySection';
import ContactFooter from './components/ContactFooter';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <OverviewSection />
      <ApproachSection />
      <FocusSection />
      <PhilosophySection />
      <ContactFooter />
    </main>
  );
}